import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { EmployeeContractType } from '../entities/employeeContractType';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class EmployeeContractTypeService extends BaseCrudService<EmployeeContractType> {

  public uri = '/api/employeeContractType/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeTtypeService');
  }

  buildSentence(entity?: EmployeeContractType, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-contract-type.service.ts